import { cva, cx, type VariantProps } from '@/cva.config';

const STATUS_LABELS: Record<string, string> = {
  error: 'error',
  needs_review: 'needs review',
  queued: 'queued',
  running: 'running',
  submitted: 'submitted',
};

export const statusChipVariants = cva({
  base: 'inline-flex w-fit items-center rounded-sm px-1.5 py-px font-mono text-2xs tracking-wide uppercase',
  defaultVariants: {
    tone: 'neutral',
  },
  variants: {
    tone: {
      attention: 'bg-score-mid/15 text-score-mid',
      neutral: 'bg-accent-soft text-accent',
      positive: 'bg-score-high/15 text-score-high',
    },
  },
});

interface StatusChipProps extends VariantProps<typeof statusChipVariants> {
  className?: string;
  status: string;
}

const ATTENTION_STATUSES = new Set(['queued', 'running', 'error']);

const statusToTone = (status: string): NonNullable<StatusChipProps['tone']> => {
  if (status === 'submitted') return 'positive';
  if (ATTENTION_STATUSES.has(status)) return 'attention';
  return 'neutral';
};

export const StatusChip = ({ className, status }: StatusChipProps) => (
  <span
    className={cx(
      statusChipVariants({ tone: statusToTone(status) }),
      className,
    )}
  >
    {STATUS_LABELS[status] ?? status}
  </span>
);
